import { create } from 'zustand';
import { apiGet, apiPatch } from '../lib/api-client';
import { showErrorToast } from './toastStore';
import type { AppSettings } from '@range-reader/shared';

const DEFAULT_SETTINGS: AppSettings = {
  colorScheme: 'standard',
  matrixDefault: 'full',
  anonymizeDefault: false,
  dataSourceDefault: 'both',
};

interface SettingsState {
  settings: AppSettings;
  loaded: boolean;
  load: () => Promise<void>;
  update: (partial: Partial<AppSettings>) => Promise<void>;
}

export const useSettingsStore = create<SettingsState>((set, get) => ({
  settings: DEFAULT_SETTINGS,
  loaded: false,

  load: async () => {
    try {
      const result = await apiGet<AppSettings>('/api/settings');
      set({ settings: result ?? DEFAULT_SETTINGS, loaded: true });
    } catch {
      set({ loaded: true });
    }
  },

  update: async (partial) => {
    const next = { ...get().settings, ...partial };
    set({ settings: next });
    try {
      await apiPatch('/api/settings', { settings: partial });
    } catch (e) {
      console.error('Failed to save settings:', e);
      showErrorToast('Failed to save settings.');
    }
  },
}));
